import React, { useMemo, useState } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactDataTable from 'react-data-table-component'
import {
    IconCheck,
    IconX,
} from '@tabler/icons-react'
import { useAuth } from '../../contexts/AuthContext'
import { useAttendance } from '../../hooks/useAttendance'

export default function Attendance() {
    const { user } = useAuth()
    const orgId = user?.orgId
    const { data: attendanceData = [], isLoading } = useAttendance(orgId)

    const daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1)

    const columns = [
        {
            name: 'Employee',
            selector: row => row.employeeName, // Adjust when data structure is known
            sortable: true,
            width: '150px',
            fixed: 'left'
        },
        ...daysInMonth.map(day => ({
            name: `${day}`,
            selector: row => {
                // Logic to match data structure
                // Placeholder: assuming row has a map of days or similar
                const record = row.attendance?.[day]
                return record ? (record.status === 'present' ? <IconCheck size={16} className="text-success" /> : <IconX size={16} className="text-danger" />) : '-'
            },
            width: '40px',
            center: true,
            compact: true
        }))
    ]

    if (isLoading) return <div className="p-20">Loading...</div>

    return (
        <>
            <Breadcrumb title="Attendance" path="Employees / Attendance" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='react-data-table'>
                    <ReactDataTable
                        columns={columns}
                        data={attendanceData}
                        pagination
                    />
                </div>
            </div>
        </>
    )
}
